/* eslint-disable import/prefer-default-export */
// GENERAL MESSAGES
export const CREATE_SUCCESS    = "Record has been created successfully";
export const UPDATE_SUCCESS    = "Record has been updated successfully";
export const DELETE_SUCCESS    = "Record has been deleted successfully";
export const RE_UPLOAD_SUCCESS = "Record has been re-uploaded successfully.";

export const IMPORTED_ACRA_LIST  = "The file's data has been imported successfully.";

export const DOCUMENT_GENERATE_SUCCESS = "Document has been generated successfully.";
export const DOCUMENT_DELETE_SUCCESS   = "Document has been deleted successfully.";

export const EMAIL_UPDATE_SUCCESS = "Email has been updated successfully.";

// AUTH MESSAGE
export const REGISTER_SUCCESS = "We have just sent you a five digit code to your email.";

// FORMATION
export const GENERATING_PRE_INCORPORATION_DOCUMENT    = "Generating pre-incorporation documents.";
export const REGENERATING_PRE_INCORPORATION_DOCUMENT  = "Re-Generating pre-incorporation documents.";
export const GENERATING_SIGNING_FORM_COMPANY_CREATE   = "Company created successfully. Generating signing form.";
export const REGENERATING_SIGNING_FORM_COMPANY_UPDATE = "Company updated successfully. Regenerating signing form.";
export const GENERATING_TRANSFER_COMPANY_DOCUMENT     = "Generating transfer company documents.";
export const REGENERATING_TRANSFER_COMPANY_DOCUMENT   = "Re-Generating transfer company documents.";


// COMPANY MESSAGES
export const COMPANY_UPDATE_SUCCESS = "The company is updated successfully.";
export const COMPANY_DELETE_SUCCESS = "The company is deleted successfully.";

export const BRIEF_PARTICULAR_UPDATE_SUCCESS = "The brief particular is updated successfully.";
export const BRIEF_PARTICULAR_DELETE_SUCCESS = "The brief particular is deleted successfully.";

export const SHARE_CAPITAL_CREATE_SUCCESS = "The Share Capital is created successfully.";
export const SHARE_CAPITAL_UPDATE_SUCCESS = "The Share Capital is updated successfully.";
export const SHARE_CAPITAL_DELETE_SUCCESS = "The Share Capital is deleted successfully.";

export const DIRECTOR_CREATE_SUCCESS = "The director is created successfully.";
export const DIRECTOR_APPROVE_SUCCESS = "The director is approved successfully.";
export const DIRECTOR_UPDATE_SUCCESS = "The director is updated successfully.";
export const DIRECTOR_DELETE_SUCCESS = "The director is deleted successfully.";

export const CEO_CREATE_SUCCESS = "The CEO is created successfully.";
export const CEO_UPDATE_SUCCESS = "The CEO is updated successfully.";
export const CEO_DELETE_SUCCESS = "The CEO is deleted successfully.";

export const SHAREHOLDER_CREATE_SUCCESS      = "The shareholder is created successfully.";
export const SAME_SHAREHOLDER_CREATE_SUCCESS = "Shareholder is created successfully. Please check in view page for details.";
export const SHAREHOLDER_UPDATE_SUCCESS      = "The shareholder is updated successfully.";
export const SHAREHOLDER_DELETE_SUCCESS      = "The shareholder is deleted successfully.";

export const REGISTRABLE_CONTROLLER_CREATE_SUCCESS = "The registrable controller is created successfully.";
export const REGISTRABLE_CONTROLLER_UPDATE_SUCCESS = "The registrable controller is updated successfully.";
export const REGISTRABLE_CONTROLLER_DELETE_SUCCESS = "The registrable controller is deleted successfully.";

export const BENEFICIAL_OWNER_CREATE_SUCCESS = "The beneficial owner is created successfully.";
export const BENEFICIAL_OWNER_UPDATE_SUCCESS = "The beneficial owner is updated successfully.";
export const BENEFICIAL_OWNER_DELETE_SUCCESS = "The beneficial owner is deleted successfully.";

export const SHARE_CERTIFICATE_CREATE_SUCCESS = "The share certificate is created successfully.";
export const SHARE_CERTIFICATE_UPDATE_SUCCESS = "The share certificate is updated successfully.";
export const SHARE_CERTIFICATE_DELETE_SUCCESS = "The share certificate is deleted successfully.";

export const ALLOTMENT_CREATE_SUCCESS = "The allotment is created successfully.";
export const ALLOTMENT_UPDATE_SUCCESS = "The allotment is updated successfully.";
export const ALLOTMENT_DELETE_SUCCESS = "The allotment is deleted successfully.";
export const ALLOTMENT_FORM_APPROVED_SUCCESS = "The allotment is approved successfully.";

export const TRANSFER_CREATE_SUCCESS = "The transfer is created successfully.";
export const TRANSFER_UPDATE_SUCCESS = "The transfer is updated successfully.";
export const TRANSFER_DELETE_SUCCESS = "The transfer is deleted successfully.";
export const TRANSFER_FORM_APPROVED_SUCCESS = "The transfer is approved successfully.";

export const DIRECTOR_INTEREST_CREATE_SUCCESS      = "The director interest is created successfully.";
export const SAME_DIRECTOR_INTEREST_CREATE_SUCCESS = "The director interest is created successfully. Please check in view page for details.";
export const DIRECTOR_INTEREST_UPDATE_SUCCESS      = "The director interest is updated successfully.";
export const DIRECTOR_INTEREST_DELETE_SUCCESS      = "The director interest is deleted successfully.";

export const CHARGE_CREATE_SUCCESS = "The charge is created successfully.";
export const CHARGE_UPDATE_SUCCESS = "The charge is updated successfully.";
export const CHARGE_DELETE_SUCCESS = "The charge is deleted successfully.";

export const DPO_CREATE_SUCCESS = "The data protection officer is created successfully.";
export const DPO_UPDATE_SUCCESS = "The data protection officer is updated successfully.";
export const DPO_DELETE_SUCCESS = "The data protection officer is deleted successfully.";

// prepare documents message
export const ANNUAL_RETURN_GENERATE_SUCCESS = "Generating annual return documents.";
export const ANNUAL_RETURN_DELETE_SUCCESS   = "The annual return is deleted successfully.";

export const AGM_GENERATE_SUCCESS = "Generating AGM documents.";
export const AGM_DELETE_SUCCESS   = "The AGM is deleted successfully.";

export const AGM_DISPENSATION_GENERATE_SUCCESS = "Generating AGM dispensation documents.";
export const AGM_DISPENSATION_DELETE_SUCCESS   = "The AGM dispensation is deleted successfully.";

export const ALLOTMENT_GENERATE_SUCCESS = "Generating allotment documents.";

export const TRANSFER_GENERATE_SUCCESS = "Generating transfer documents.";

export const STRIKE_OFF_GENERATE_SUCCESS = "Generating strike off documents.";
export const STRIKE_OFF_DELETE_SUCCESS   = "The strike off is deleted successfully.";

export const CHANGE_OF_FYE_GENERATE_SUCCESS = "Generating director resolutions documents.";
export const CHANGE_OF_FYE_DELETE_SUCCESS   = "The director resolutions is deleted successfully.";

export const DIRECTOR_FEE_GENERATE_SUCCESS = "Generating director fee documents.";
export const DIRECTOR_FEE_DELETE_SUCCESS   = "The director fee is deleted successfully.";

export const CHANGE_DIRECTOR_GENERATE_SUCCESS = "Generating director changes documents.";
export const CHANGE_DIRECTOR_DELETE_SUCCESS   = "The director changes is deleted successfully.";

export const CHANGE_NOMINATOR_GENERATE_SUCCESS = "Generating nominator changes documents.";
export const CHANGE_NOMINATOR_DELETE_SUCCESS   = "The nominator changes is deleted successfully.";

export const CHANGE_SHAREHOLDER_NOMINATOR_GENERATE_SUCCESS = "Generating shareholder nominator changes documents.";
export const CHANGE_SHAREHOLDER_NOMINATOR_DELETE_SUCCESS   = "The shareholder nominator changes is deleted successfully.";

export const CHANGE_AUDITOR_GENERATE_SUCCESS = "Generating auditor changes documents.";
export const CHANGE_AUDITOR_DELETE_SUCCESS   = "The auditor changes is deleted successfully.";

export const CHANGE_RO_GENERATE_SUCCESS = "Generating register office address changes documents.";
export const CHANGE_RO_DELETE_SUCCESS   = "The register office address changes is deleted successfully.";
export const CHANGE_RO_APPROVED_SUCCESS = "The register office address changes is approved successfully.";

export const BUSINESS_ACTIVITIES_GENERATE_SUCCESS = "Generating business activities changes documents.";
export const BUSINESS_ACTIVITIES_DELETE_SUCCESS   = "The business activities changes is deleted successfully.";
export const CHANGE_BUSINESS_ACTIVITIES_APPROVED_SUCCESS = "The business activities changes is approved successfully.";
export const CHANGE_OF_COMPANY_NAME_APPROVED_SUCCESS = "The company name changes is approved successfully.";

export const INTERIM_DIVIDEND_GENERATE_SUCCESS = "Generating interim dividend documents.";
export const INTERIM_DIVIDEND_DELETE_SUCCESS   = "The interim dividend is deleted successfully.";

export const SHARE_CANCELLATION_GENERATE_SUCCESS = "Generating share cancellation documents.";
export const SHARE_CANCELLATION_DELETE_SUCCESS   = "The share cancellation is deleted successfully.";

export const SHARE_BUY_BACK_GENERATE_SUCCESS = "Generating share buy back documents.";
export const SHARE_BUY_BACK_DELETE_SUCCESS   = "The share buy back is deleted successfully.";

export const PARTICULARS_OF_DIRECTOR_GENERATE_SUCCESS = "Generating the update of directors' particulars documents.";
export const PARTICULARS_OF_DIRECTOR_DELETE_SUCCESS   = "The update of directors' particulars documents deleted successfully.";

export const PARTICULARS_OF_SHAREHOLDER_GENERATE_SUCCESS = "Generating the update of shareholders' particulars documents.";
export const PARTICULARS_OF_SHAREHOLDER_DELETE_SUCCESS   = "The update of shareholders' particulars documents deleted successfully.";

export const SALE_OF_PROPERTY_GENERATE_SUCCESS = "Generating sale of property documents.";
export const SALE_OF_PROPERTY_DELETE_SUCCESS   = "The sale of property is deleted successfully.";

export const INCREASE_CAPITAL_AMOUNT_GENERATE_SUCCESS = "Generating update paid up capital documents.";
export const INCREASE_CAPITAL_AMOUNT_DELETE_SUCCESS   = "The update paid up capital documents deleted successfully.";

export const DATA_PROTECTION_OFFICER_FORM_GENERATE_SUCCESS = "Generating data protection officer documents.";
export const DATA_PROTECTION_OFFICER_FORM_DELETE_SUCCESS   = "The data protection officer form has been deleted successfully.";
export const DATA_PROTECTION_OFFICER_FORM_APPROVED_SUCCESS = "The data protection officer form has been approved successfully.";

export const CHANGE_OF_COMPANY_NAME_FORM_GENERATE_SUCCESS = "Generating change of company name documents.";
export const CHANGE_OF_COMPANY_NAME_FORM_DELETE_SUCCESS   = "The change of company name form has been deleted successfully.";
export const CHANGE_OF_COMPANY_NAME_FORM_APPROVED_SUCCESS = "The change of company name form has been approved successfully.";

// COMPANY, SETUP MESSAGES
export const AUDITOR_CREATE_SUCCESS = "The auditor is created successfully.";
export const AUDITOR_UPDATE_SUCCESS = "The auditor is updated successfully.";
export const AUDITOR_DELETE_SUCCESS = "The auditor is deleted successfully.";
export const AUDITOR_APPROVE_SUCCESS = "The auditor is approved successfully.";

export const SECRETARY_CREATE_SUCCESS = "The secretary is created successfully.";
export const SECRETARY_UPDATE_SUCCESS = "The secretary is updated successfully.";
export const SECRETARY_DELETE_SUCCESS = "The secretary is deleted successfully.";

export const SECRETARIES_RESIGNATION_GENERATE_SUCCESS = "Generating secretary resignation documents.";
export const SECRETARIES_RESIGNATION_DELETE_SUCCESS   = "The secretary resignation is deleted successfully.";
export const SECRETARIES_RESIGNATION_APPROVE_SUCCESS  = "The secretary resignation is approved successfully.";
export const SECRETARIES_APPOINTMENT_APPROVE_SUCCESS  = "The secretary appointment is approved successfully.";

export const NOMINEE_DIRECTOR_CREATE_SUCCESS = "The nominee director is created successfully.";
export const NOMINEE_DIRECTOR_UPDATE_SUCCESS = "The nominee director is updated successfully.";
export const NOMINEE_DIRECTOR_DELETE_SUCCESS = "The nominee director is deleted successfully.";

export const NOMINATOR_CHANGE_APPROVE_SUCCESS = "The nominator changes has been approved successfully.";

export const SHAREHOLDER_NOMINATOR_CHANGE_APPROVE_SUCCESS = "The shareholder nominator changes has been approved successfully.";

export const NOMINEE_SHAREHOLDER_CREATE_SUCCESS = "The nominee shareholder is created successfully.";
export const NOMINEE_SHAREHOLDER_UPDATE_SUCCESS = "The nominee shareholder is updated successfully.";
export const NOMINEE_SHAREHOLDER_DELETE_SUCCESS = "The nominee shareholder is deleted successfully.";

// SIGN MESSAGES
export const DOWNLOAD_REQUEST_SUCCESS                    = "Your request is being processed. You can track the progress in Download Center.";
export const SEND_MAIL_SIGNATURE_REQUEST_SUCCESS         = "Emailing the users to request their signature on the relevant documents.";
export const SINGLE_DOCUMENT_SUBMITTED_TO_SIGN_MESSAGE   = "Your document is submitted to sign. Please check back in a while";
export const MULTIPLE_DOCUMENT_SUBMITTED_TO_SIGN_MESSAGE = "All of your documents are submitted to sign. Please check back in a while.";
export const MAIL_SENT_SUCCESS                           = "Emails have been sent.";

// COMPLIANCE
export const SYSTEM_CHECKED_SUCCESS = "System checked successfully.";

// PROFILE MESSAGES
export const USER_INFO_UPDATE_SUCCESS = "The user information is updated successfully.";
export const PROFILE_UPDATE_SUCCESS   = "The profile is updated successfully.";
export const PASSWORD_UPDATE_SUCCESS  = "Password updated successfully.";

// SIGNATURE MESSAGES
export const SIGNATURE_SAVE_SUCCESS   = "The signature is saved successfully.";
export const SIGNATURE_SELECT_SUCCESS = "Default signature is updated successfully.";
export const SIGNATURE_DELETE_SUCCESS = "The signature is deleted successfully.";

// SETUP MESSAGES
export const FEE_CREATE_SUCCESS = "The fee is created successfully.";
export const FEE_UPDATE_SUCCESS = "The fee is updated successfully.";

export const OFFICER_CREATE_SUCCESS = "The officer is created successfully.";
export const OFFICER_UPDATE_SUCCESS = "The officer is updated successfully.";
export const OFFICER_DELETE_SUCCESS = "The officer is deleted successfully.";

export const OPERATING_HOUR_CREATE_SUCCESS = "The operating hour is created successfully.";
export const OPERATING_HOUR_UPDATE_SUCCESS = "The operating hour is updated successfully.";
export const OPERATING_HOUR_DELETE_SUCCESS = "The operating hour is deleted successfully.";

export const SECRETARY_FIRM_CREATE_SUCCESS = "The secretary firm is created successfully.";
export const SECRETARY_FIRM_UPDATE_SUCCESS = "The secretary firm is updated successfully.";
export const SECRETARY_FIRM_DELETE_SUCCESS = "The secretary firm is deleted successfully.";

export const SHARE_TYPE_CREATE_SUCCESS = "The share type is created successfully.";
export const SHARE_TYPE_UPDATE_SUCCESS = "The share type is updated successfully.";
export const SHARE_TYPE_DELETE_SUCCESS = "The share type is deleted successfully.";


